import { config } from 'aws-sdk';
import jwt from 'jsonwebtoken'
import Config from '../config/Config';

export const activateProctor = (RPToken) => {

	/*if(!RPToken || RPToken === '') {
		alert("coming here")
		window.proctorStarted = false;
		localStorage.setItem('RPToken', '')
		window.location.reload()
	}*/

	window.remoteProctoring.remoteProctorInitV2({ authToken: RPToken }).then(function () {
		// start proctoring session
		window.proctorStarted = true;
		console.log('proctor start');
		localStorage.setItem('RPStart', '1')
		//return window.supervisor.start();
	})
		.catch(function (err) {
			// show alert with an error
			console.log('proctor launch error', err);
			window.proctorStarted = false;
			localStorage.setItem('RPToken', '')
			window.location.reload()
		});
	return RPToken;
};

export const stopProctor = () => {
	if (window.proctorStarted) {
		window.proctorStarted = false;
		console.log('proctor 1 stop');
		window.remoteProctoring.stop();
	} else {
		window.remoteProctoring.stop();
	}
};

export const checkProctorStatus = () => {
	return window.proctorStarted
}

export const RPStart = ({ courseId, elementId, loginId, proctorEventName }) => {
	try {
		const jwtSecret = Config.RP_JWT_SECRET;
		const rpOrgId = Config.RP_ORGID;

		if (!jwtSecret) {
			throw new Error('JWT secret is not configured');
		}

		if (!proctorEventName) {
			throw new Error('Proctor event name is required.');
		}

		const jwtPayload = {
			organisationId: rpOrgId,
			sourceEventId: proctorEventName,
			eventName: proctorEventName,
			candidateName: loginId,
			candidateId: `${loginId}-${courseId}-${elementId}`,
			examDurationInMins: 60,
			iat: Math.floor(Date.now() / 1000),
			exp: Math.floor(Date.now() / 1000) + 3600,
		};

		// console.log('RPStart creating JWT with payload:', jwtPayload);

		const token = jwt.sign(jwtPayload, jwtSecret);

		localStorage.setItem('RPToken', token);

		if (!checkProctorStatus()) {
			activateProctor(token);
		}

		// console.log(proctorEventName);
		return token;
	} catch (error) {
		console.error('RPStart error:', error);
		return null;
	}
}